<template>
	<div>
		<div class="cards" v-if="!loading">
			<div class="vx-row">
				<div class="vx-col lg:w-1/3 md:w-1/2 w-full mb-base">
					<vx-card title="Gegevens">
						<template slot="actions">
							<vs-row>
								<div class="mr-2">
									<vx-tooltip class="flex" text="Hoe en wat?">
										<font-awesome-icon icon="edit" @click="showUserPopup"></font-awesome-icon>
									</vx-tooltip>
								</div>
								<vx-tooltip class="flex" text="Hoe en wat?">
									<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
								</vx-tooltip>
							</vs-row>
						</template>
						<vs-row>
							<vs-col vs-w="6"><b>Naam:</b></vs-col>
							<vs-col vs-w="6">{{ user.name }}</vs-col>

							<vs-col vs-w="6"><b>E-mail:</b></vs-col>
							<vs-col vs-w="6">{{ user.email }}</vs-col>

							<vs-col vs-w="6"><b>Telefoon:</b></vs-col>
							<vs-col vs-w="6">{{ user.phone }}</vs-col>

								<vs-col vs-w="6"><b>Afzender:</b></vs-col>
								<vs-col vs-w="6">{{ user.return_address }}</vs-col>

						</vs-row>
					</vx-card>
				</div>

				<div class="vx-col lg:w-1/3 md:w-1/2 w-full mb-base">
					<vx-card title="Bedrijfsgegevens">
						<template slot="actions">
							<vs-row>
								<div class="mr-2">
									<vx-tooltip class="flex" text="Hoe en wat?">
										<font-awesome-icon icon="edit" @click="showCompanyPopup"></font-awesome-icon>
									</vx-tooltip>
								</div>
								<vx-tooltip class="flex" text="Hoe en wat?">
									<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
								</vx-tooltip>
							</vs-row>
						</template>
						<vs-row>
							<vs-col vs-w="6"><b>Bedrijfs naam:</b></vs-col>
							<vs-col vs-w="6">{{ user.company }}</vs-col>

							<vs-col vs-w="6"><b>Kvk nummer:</b></vs-col>
							<vs-col vs-w="6">{{ user.chamberofcommercenumber }}</vs-col>

							<vs-col vs-w="6"><b>Adres:</b></vs-col>
							<vs-col vs-w="6">{{ user.address }}</vs-col>

							<vs-col vs-w="6"><b>Postcode:</b></vs-col>
							<vs-col vs-w="6">{{ user.postalcode }}</vs-col>

							<vs-col vs-w="6"><b>Plaatsnaam:</b></vs-col>
							<vs-col vs-w="6">{{ user.city }}</vs-col>

							<vs-col vs-w="6"><b>Land:</b></vs-col>
							<vs-col vs-w="6">{{ user.country }}</vs-col>
						</vs-row>
					</vx-card>
				</div>

				<div class="vx-col lg:w-1/3 md:w-1/2 w-full mb-base">
					<vx-card title="Beveiliging" class="card-img-top">
						<template slot="actions">
							<vx-tooltip class="flex" text="Hoe en wat?">
								<font-awesome-icon icon="question-circle" @click="wikiPassword"></font-awesome-icon>
							</vx-tooltip>
						</template>
						<vs-row>
							<vs-col vs-w="6"><b>Wachtwoord:</b></vs-col>
							<vs-col vs-w="6">**********</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-w="12">
								<vs-button type="flat" @click.native="showPasswordPopup()" class="float-right">Wachtwoord bewerken</vs-button>
							</vs-col>
						</vs-row>
					</vx-card>
				</div>

			</div>
		</div>

		<div class="popups">
			<vs-popup title="Gegevens bewerken" :active.sync="popupActivo">
				<form data-vv-scope="userForm">
					<div class="vx-row">
						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Naam" v-validate="'required|alpha_spaces'" name="name"
									  v-model="user.name"/>
							<span class="text-danger text-sm" v-show="errors.has('userForm.name')">{{ errors.first('userForm.name') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="E-mail" disabled="true" v-model="user.email"/>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Telefoon"
									  v-validate="{required: true,
                regex:'^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))|(((\\\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$'}"
									  name="phone" type="number" v-model="user.phone"/>
							<span class="text-danger text-sm phoneNumber"
								  v-show="errors.has('userForm.phone')">{{ errors.first('userForm.phone') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Afzender adres (voor A6 label)" name="return_address"
									  v-model="user.return_address"/>
							<span class="text-danger text-sm" v-show="errors.has('userForm.return_address')">{{ errors.first('userForm.return_address') }}</span>
						</div>

						<div class="vx-col w-full mb-base ">
							<vs-button class="mr-1" color="primary" @click.prevent="submitForm('userForm')">Opslaan</vs-button>
							<vs-button color="danger" type="border" @click.native="CancelEdit">Anuleren</vs-button>
						</div>
					</div>
				</form>
			</vs-popup>

			<vs-popup title="Bedrijfsgegevens bewerken" :active.sync="popupActivo2">
				<form data-vv-scope="companyForm">
					<div class="vx-row">
						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Bedrijfs naam" name="company" v-validate="'required|alpha_spaces'"
									  v-model="user.company"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('companyForm.company')">{{ errors.first('companyForm.company') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Kvk nummer" name="chamberofcommercenumber" v-validate="'required|digits:8'"
									  type="number"
									  v-model="user.chamberofcommercenumber"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('companyForm.chamberofcommercenumber')">{{
									errors.first('companyForm.chamberofcommercenumber')
								}}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Adres" v-validate="{required: true,
                regex:'^([1-9][e][\\s])*([a-zA-Z]+(([\\.][\\s])|([\\s]))?)+[1-9][0-9]*(([-][1-9][0-9]*)|([\\s]?[a-zA-Z]+))?$'}"
									  name="address" v-model="user.address"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('companyForm.address')">{{ errors.first('companyForm.address') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Postcode" name="postalcode" v-validate="{required: true,
                regex:'^[1-9][0-9]{3}[\\s]?[A-Za-z]{2}$'}" v-model="user.postalcode"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('companyForm.postalcode')">{{ errors.first('companyForm.postalcode') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Plaatsnaam" v-validate="'required|alpha_spaces'" name="city"
									  v-model="user.city"/>
							<span class="text-danger text-sm" v-show="errors.has('companyForm.city')">{{ errors.first('companyForm.city') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Land" disabled="" v-model="user.country"/>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-button class="mr-1" color="primary" @click.prevent="submitForm('companyForm')">Opslaan</vs-button>
							<vs-button color="danger" type="border" @click.native="CancelEdit">Annuleren</vs-button>
						</div>
					</div>
				</form>
			</vs-popup>

			<vs-popup title="Wachtwoord wijzigen" :active.sync="popupActivo3">

				<form data-vv-scope="passwordForm">

					<div class="vx-row">
						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Huidige wachtwoord" type="password" v-validate="'required|min:1|max:191'"
									  name="currentpassword"
									  v-model="passwordData.password"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('passwordForm.currentpassword')">{{ errors.first('passwordForm.currentpassword') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Nieuw wachtwoord" type="password" v-validate="'required|min:1|max:191'"
									  name="newpassword"
									  ref="newpassword"
									  v-model="resetPassword.newpassword"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('passwordForm.newpassword')">{{ errors.first('passwordForm.newpassword') }}</span>
						</div>
						<div class="vx-col w-full mb-base">
							<vs-input class="w-full" label="Bevestig nieuw wachtwoord" type="password"
									  v-validate="'required|min:1|max:191|confirmed:newpassword'" name="confirmpassword"
									  v-model="resetPassword.confirmpassword"/>
							<span class="text-danger text-sm"
								  v-show="errors.has('passwordForm.confirmpassword')">{{ errors.first('passwordForm.confirmpassword') }}</span>
						</div>

						<div class="vx-col w-full mb-base">
							<vs-button class="mr-1" @click.prevent="submitPasswordForm('passwordForm')">Opslaan</vs-button>
							<vs-button color="danger" type="border" @click.native="CancelEdit">Annuleren</vs-button>
						</div>
					</div>
				</form>
			</vs-popup>
		</div>
	</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);

const dict = {
	custom: {
		name: {
			required: 'Voer alstublieft je naam in',
			alpha_spaces: 'Je naam kan alleen uit letters bestaan'
		},
		phone: {
			required: 'Voer alstublieft je telefoon nummer in',
			regex: 'Dit is geen geldig telefoon nummer'
		},
		company: {
			required: 'Voer alstublieft je bedrijfs naam in',
			alpha_spaces: 'Je bedrijfs naam kan alleen uit letters bestaan'
		},
		chamberofcommercenumber: {
			required: 'Voer alstublieft je Kvk nummer in',
			digits: 'je Kvk nummer moet 8 cijfers lang zijn'
		},
		address: {
			required: 'Voer alstublieft je adres in',
			regex: 'Dit is geen geldig adres'
		},
		postalcode: {
			required: 'Voer alstublieft je postcode in',
			regex: 'Dit is geen geldige postcode'
		},
		city: {
			required: 'Voer alstublieft je plaatsnaam in',
			alpha_spaces: 'Je plaatsnaam kan alleen uit letters bestaan'
		},
		currentpassword: {
			required: 'Voer alstublieft je wachtwoord in',
			min: 'Voer alstublieft je wachtwoord in',
			max: 'Het wachtwoord kan maximaal 191 tekens lang zijn',
			credentials: 'Het wachtwoord is onjuist ingevuld',
		},
		newpassword: {
			required: 'Voer alstublieft een nieuw wachtwoord in',
			min: 'Voer alstublieft een nieuw wachtwoord in',
			max: 'Het wachtwoord kan maximaal 191 tekens lang zijn',
		},
		confirmpassword: {
			required: 'Voer alstublieft het nieuwe wachtwoord opnieuw in',
			min: 'Voer alstublieft het nieuwe wachtwoord opnieuw in',
			max: 'Het wachtwoord kan maximaal 191 tekens lang zijn',
			confirmed: 'Dit wachtwoord moet het zelfde zijn als het nieuwe wachtwoord',
		},

	}
};
Validator.localize('en', dict);

export default {
	name: 'Profile',
	computed: {
		...mapGetters({
			authenticated: 'auth/authenticated',
		}),
	},
	mounted() {
		this.getData()
	},
	data() {
		return {
			loading: true,
			popupActivo: false,
			popupActivo2: false,
			popupActivo3: false,
			user: {},
			passwordData: {},
			resetPassword: {},
		}
	},
	watch: {
		popupActivo() {
			this.resetData()
		},
		popupActivo2() {
			this.resetData()
		},
		popupActivo3() {
			this.resetData()
		}
	},
	methods: {
		getData() {
			this.$vs.loading();

			this.user = this.$store.state.userStore.user;
			this.loading = false;
			setTimeout(() => {
				this.$vs.loading.close();
			}, 200);
		},
		resetData() {
			// setTimeout(() => this.getData(), 1000)
			// this.$store.dispatch('userStore/attemptGetUser');
			this.user = this.$store.state.userStore.user;
			this.resetPassword = {};
			this.passwordData = {};
		},
		CancelEdit() {
			this.clearData()
		},
		submitForm(scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					this.$store.dispatch('userStore/changeUserData', this.user).then(res => {
						this.clearData();

						this.$vs.notify({
							title: 'Gelukt!',
							text: 'Je gegevens zijn opgeslagen',
							color: 'success'
						})
					}).catch(error => {
						console.log(error);
						this.$vs.notify({
							title: 'Error',
							text: 'Er is iets fout gegaan',
							color: 'danger'
						})
					});

				}
			})
		},
		submitPasswordForm(scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					this.$store.dispatch('userStore/checkUserPassword', this.passwordData).then(res => {
						if (this.$store.state.userStore.password_correct) {
							this.$store.dispatch('userStore/changeUserPassword', this.resetPassword).then(res => {
								this.clearData();

								this.$vs.notify({
									title: 'Gelukt!',
									text: 'Je gegevens zijn opgeslagen',
									color: 'success'
								})
							}).catch(error => {
								this.$vs.notify({
									title: 'Oops!',
									text: 'Er is iets fout gegaan',
									color: 'danger'
								})
							});
						} else {
							this.$validator.errors.add({
								field: 'passwordForm.currentpassword',
								msg: 'Het ingevulde wachtwoord is onjuist'
							});
						}
					}).catch(error => {
						this.$vs.notify({
							title: 'Error',
							text: 'Er is iets fout gegaan',
							color: 'danger'
						})
					});
				}
			})
		},
		showUserPopup() {
			this.popupActivo = true;
		},
		showCompanyPopup() {
			this.popupActivo2 = true;
		},
		showPasswordPopup() {
			this.popupActivo3 = true;
		},
		clearData() {
			this.popupActivo = false;
			this.popupActivo2 = false;
			this.popupActivo3 = false;
			this.passwordData = {};
			this.resetPassword = {};
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.userdata)
		},
		wikiPassword() {
			window.open(this.$store.state.wiki.wiki.passwordChange)
		}
	}
}
</script>
